import { buildPhotoUrl, extractPathFromProxyUrl } from "@/lib/photoProxy";

const PUBLIC_BUCKETS = new Set(["appraisal-photos", "expense-receipts", "release-keys", "driver-avatars", "company-logos"]);

/** Preserve local/custom sources and signed/private URLs. Never guess another URL's bucket or origin. */
export function resolvePhotoTileSource(raw: string, bucket: string, previews: boolean): { original: string; preview: string; transformed: boolean } {
  let original = raw;
  if (!raw) return { original, preview: original, transformed: false };
  const legacy = extractPathFromProxyUrl(raw);
  if (legacy) original = buildPhotoUrl(legacy.bucket, legacy.path);
  else if (!/^[a-z][a-z\d+.-]*:/i.test(raw) && !raw.startsWith("/")) {
    const path = raw.startsWith(`${bucket}/`) ? raw.slice(bucket.length + 1) : raw;
    original = buildPhotoUrl(bucket, path);
  }
  let preview = original;
  if (previews) {
    try {
      const url = new URL(original);
      const configured = new URL(import.meta.env.VITE_SUPABASE_URL);
      const match = url.pathname.match(/^\/storage\/v1\/object\/public\/([^/]+)\/(.+)$/);
      // Transformation eligibility is source-based, never job-based, and only for this backend's known public buckets.
      if (url.origin === configured.origin && match && PUBLIC_BUCKETS.has(match[1])) {
        url.pathname = `/storage/v1/render/image/public/${match[1]}/${match[2]}`;
        url.search = "width=320&height=320&resize=contain&quality=70";
        preview = url.toString();
      }
    } catch { /* blob/data/relative/custom sources remain unchanged */ }
  }
  return { original, preview, transformed: preview !== original };
}
